import React from "react";

type DriverDeliveriesFiltersProps = {
  dateFrom: string;
  dateTo: string;
  addressQuery: string;
  onChangeFrom: (value: string) => void;
  onChangeTo: (value: string) => void;
  onChangeAddress: (value: string) => void;
  onToday: () => void;
  onWeek: () => void;
  onClear: () => void;
  onDownloadXls: () => void;
};

const wrapperStyle: React.CSSProperties = {
  border: "1px solid var(--border)",
  borderRadius: "22px",
  background: "var(--surface)",
  boxShadow: "var(--shadow)",
  padding: "16px",
  display: "grid",
  gridTemplateColumns: "180px 180px minmax(240px, 1fr) auto",
  gap: "14px",
  alignItems: "end",
};

const fieldWrapStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

const labelStyle: React.CSSProperties = {
  fontSize: "12px",
  fontWeight: 700,
  color: "var(--text-secondary)",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const inputStyle: React.CSSProperties = {
  minHeight: "44px",
  borderRadius: "14px",
  border: "1px solid var(--border)",
  background: "var(--surface-alt)",
  color: "var(--text-primary)",
  padding: "0 12px",
  fontSize: "14px",
};

const actionsStyle: React.CSSProperties = {
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
  justifyContent: "flex-end",
};

const secondaryButtonStyle: React.CSSProperties = {
  minHeight: "44px",
  borderRadius: "14px",
  border: "1px solid var(--border)",
  background: "var(--surface-alt)",
  color: "var(--text-primary)",
  padding: "0 14px",
  fontSize: "14px",
  fontWeight: 700,
  cursor: "pointer",
};

const primaryButtonStyle: React.CSSProperties = {
  ...secondaryButtonStyle,
  background: "var(--primary-soft)",
};

const DriverDeliveriesFilters = ({
  dateFrom,
  dateTo,
  addressQuery,
  onChangeFrom,
  onChangeTo,
  onChangeAddress,
  onToday,
  onWeek,
  onClear,
  onDownloadXls,
}: DriverDeliveriesFiltersProps) => {
  return (
    <div style={wrapperStyle}>
      <div style={fieldWrapStyle}>
        <label style={labelStyle}>Desde</label>
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => onChangeFrom(e.target.value)}
          style={inputStyle}
        />
      </div>

      <div style={fieldWrapStyle}>
        <label style={labelStyle}>Hasta</label>
        <input
          type="date"
          value={dateTo}
          onChange={(e) => onChangeTo(e.target.value)}
          style={inputStyle}
        />
      </div>

      <div style={fieldWrapStyle}>
        <label style={labelStyle}>Dirección</label>
        <input
          type="text"
          value={addressQuery}
          onChange={(e) => onChangeAddress(e.target.value)}
          style={inputStyle}
          placeholder="Buscar por dirección"
        />
      </div>

      <div style={actionsStyle}>
        <button style={secondaryButtonStyle} onClick={onToday}>
          Hoy
        </button>
        <button style={secondaryButtonStyle} onClick={onWeek}>
          Últimos 7 días
        </button>
        <button style={secondaryButtonStyle} onClick={onClear}>
          Limpiar
        </button>
        <button style={primaryButtonStyle} onClick={onDownloadXls}>
          Descargar XLS
        </button>
      </div>
    </div>
  );
};

export default DriverDeliveriesFilters;